//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionCamera(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.47 4L16.21 2.5H7.79L6.53 4H2V16H4V6H7.47L8.73 4.5H15.27L16.53 6H20V18H2V20H22V4H17.47Z" fill="currentColor" /><path d="M17 11.5C17 8.74 14.76 6.5 12 6.5C9.24 6.5 7 8.74 7 11.5C7 14.26 9.24 16.5 12 16.5C14.76 16.5 17 14.26 17 11.5ZM9 11.5C9 9.85 10.35 8.5 12 8.5C13.65 8.5 15 9.85 15 11.5C15 13.15 13.65 14.5 12 14.5C10.35 14.5 9 13.15 9 11.5Z" fill="currentColor" /></svg>;
}
export default IconActionCamera;